import React, { useEffect } from "react";
import queryString from 'query-string';

// reactstrap components
import { Card, CardBody, Row, Col } from "reactstrap";


// services
import { showMessage } from "../../services/message.js";
import { api_GET } from "../../services/api_service.js";
import { formateDate } from "../../helpers/formats";

//Context
import { useAuth } from "../../context/auth.js";

//Components
import LogoSistema from "../../components/LogoSistema/LogoSistema.jsx";

export default function CarteirinhaGG({ history }) {

    const { setLoading, setupSistema } = useAuth();

    var QRCode = require('qrcode.react');

    const [dadoscarteirinha, set_dadoscarteirinha] = React.useState(null);
    const loadDados = () => {
        let urls = history.location.search;
        let params = queryString.parse(urls);

        setLoading(true);
        api_GET('ProtocoloGerador/ByNumeroProtocolo/' + params.protocolo).then(result => {
            if (["Cancelado", "Pendente", "Inativo"].includes(result.data.status)) {
                if (result.data.status == "Inativo") {
                    showMessage("Aviso", "Cadastro Inativo no Sistema.", 'error', null);
                    return;
                } else {
                    showMessage("Aviso", "Carteirinha não disponível", 'error', null);
                    return;
                }
            }

            let protocolo = result.data;

            const _sigla = protocolo?.setupSolicitacaoAcaoNovoCadastro?.setupSolicitacao?.categoria?.sigla;

            // array dos locais
            const _enderencosLocais = protocolo.protocoloGerador && protocolo.protocoloGerador[0].protocoloGeradorLocais
                ? protocolo.protocoloGerador[0].protocoloGeradorLocais.filter(local => {
                    if (_sigla === 'RGG')
                        return local.protocoloGeradorLocalContratos &&
                            local.protocoloGeradorLocalContratos.length > 0 &&
                            local.protocoloGeradorLocalContratos.every(c => c.statusRegularidade === "Regular");
                    return true;
                })
                : [];
            let _carteirinha = {
                sigla: protocolo?.setupSolicitacaoAcaoNovoCadastro?.setupSolicitacao?.categoria?.sigla,
                codCadastro: protocolo.codigoCadastro,
                validade: protocolo.dataFimVigencia,
                documento: protocolo.cpf_Cnpj ?? "",
                nome: protocolo?.protocoloGerador?.[0]?.razaoSocial,
                endereco: _enderencosLocais,
                protocolo: params.protocolo,
            }
            set_dadoscarteirinha(_carteirinha);
        })
            .catch(err => showMessage("Aviso", err.message, 'error', null))
            .finally(() => setLoading(false));
    }

    useEffect(() => {
        loadDados();
    }, []);

    return (
        <>
            {dadoscarteirinha != null &&
                <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                    <Card style={{ width: "15cm" }}>
                        <CardBody>
                            <div style={{ border: "1px solid black", padding: "0.5cm" }}>
                                <Row style={{ marginTop: "1cm" }}>
                                    <Col md="4">
                                        <LogoSistema identificacaoLogo={"logotipo"} width='100' />
                                    </Col>
                                    <Col md="4" className="text-center">
                                        <p>Grandes Geradores de Resíduos {dadoscarteirinha.sigla == "RGG" ? "Sólidos" : "Inertes"}</p>
                                    </Col>
                                    <Col md="4" className="text-right">
                                        <LogoSistema identificacaoLogo={"logoSecundario"} width='130' />
                                    </Col>
                                    <Col md="6">
                                        <b>Nº de Cadastro: </b> <br />{dadoscarteirinha.codCadastro}
                                    </Col>
                                    <Col md="6">
                                        <b>Validade: </b> <br /> {formateDate(dadoscarteirinha.validade)}
                                    </Col>
                                    <Col md="12" className="mt-4">
                                        <b>{dadoscarteirinha.documento.length > 11 ? "CNPJ" : "CPF"}: </b> {dadoscarteirinha.documento}
                                    </Col>
                                    <Col md="12">
                                        <b>{dadoscarteirinha.documento.length > 11 ? "Razão Social" : "Nome"}: </b> {dadoscarteirinha.nome}
                                    </Col>
                                    {dadoscarteirinha.endereco.length > 0 && dadoscarteirinha.endereco.map((value, index) => (
                                        <Col md="12" key={index}>
                                            <b>Endereço{dadoscarteirinha.endereco.length > 1 ? `(${index + 1}):` : ":"} </b> {value.logradouro + ", " + value.numEndereco + ", " + value.bairro}
                                        </Col>
                                    ))}
                                </Row>
                                <Row>
                                    <Col md="12" className="text-center">
                                        <QRCode value={setupSistema?.urL_WEB_ROC + "/empty/CarteirinhaGG?protocolo=" + dadoscarteirinha.protocolo} />
                                    </Col>
                                </Row>
                            </div>
                        </CardBody>
                    </Card>
                </div>
            }
        </>
    );
}